import React from 'react';
import cn from 'classnames';
import isEqual from 'lodash/isEqual';
import Button from '@creditflowresearch/uilib/Button';
import styles from './footer.module.scss';

interface IProps {
  className?: string,
  isEmpty?: boolean,
  innerRef?: React.ReactNode,
  filters?: {},
  appliedFilters?: {},
  initialFilters?: {},
  onApply?: () => void,
  onReset?: () => void,
  onTagRemove?: (fieldName: string, value: any) => void,
  tagsComponent?: React.ReactNode | {} | (() => React.ReactNode),
}

const Footer = React.forwardRef(({
  tagsComponent: TagsComponent,
  className,
  isEmpty = false,
  initialFilters,
  filters,
  appliedFilters,
  innerRef,
  onTagRemove,
  onApply,
  onReset,
}: IProps, ref) => {
  const isApplyDisabled = isEqual(filters, appliedFilters) ||
      (isEqual(initialFilters, appliedFilters)
          && isEqual(initialFilters, filters));
  const isResetDisabled =
      (isEqual(initialFilters, appliedFilters)
          && isEqual(initialFilters, filters));

  return (
    <div
      className={ cn(className, { [styles.isEmpty]: isEmpty }) }
      // @ts-ignore
      ref={ ref || innerRef }
      data-test="filtersFooter"
    >
      <div
        className={ styles.footerTags }
        data-test="tags"
      >
        { /* @ts-ignore */ }
        <TagsComponent
          filters={ filters }
          onTagRemove={ onTagRemove }
        />
      </div>
      <div
        className={ styles.footerActions }
        data-test="actions"
      >
        <Button
          variant="solid"
          onClick={ isApplyDisabled ? () => {} : onApply }
          disabled={ isApplyDisabled }
          dataTest="applyFiltersButton"
        >
          Apply
        </Button>
        <Button
          variant="text"
          onClick={ isResetDisabled ? () => {} : onReset }
          disabled={ isResetDisabled }
          dataTest="resetFiltersButton"
        >
          Reset
        </Button>
      </div>
    </div>
  );
});

export default Footer;
